import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import KeysPage from './pages/KeysPage';
import VersionPage from './pages/VersionPage';
import UsersPage from './pages/UsersPage';
import DevicesPage from './pages/DevicesPage';
import RolesPage from './pages/RolesPage';
import TechUsersPage from './pages/TechUsersPage';
import PlansPage from './pages/PlansPage';
import PaymentsPage from './pages/PaymentsPage';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardHome from './pages/DashboardHome';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardHome />} />
          <Route path="keys" element={<ProtectedRoute permission="licenseKeys"><KeysPage /></ProtectedRoute>} />
          <Route path="versions" element={<ProtectedRoute permission="appVersions"><VersionPage /></ProtectedRoute>} />
          <Route path="users" element={<ProtectedRoute permission="users"><UsersPage /></ProtectedRoute>} />
          <Route path="devices" element={<ProtectedRoute permission="devices"><DevicesPage /></ProtectedRoute>} />
          <Route path="roles" element={<ProtectedRoute superAdminOnly><RolesPage /></ProtectedRoute>} />
          <Route path="tech-users" element={<ProtectedRoute superAdminOnly><TechUsersPage /></ProtectedRoute>} />
          <Route path="plans" element={<ProtectedRoute superAdminOnly><PlansPage /></ProtectedRoute>} />
          <Route path="payments" element={<ProtectedRoute superAdminOnly><PaymentsPage /></ProtectedRoute>} />
        </Route>
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="*" element={<Navigate to="/admin/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
